<template>
  <main class="campaign-extensions">
    <section class="extensions-bar">
      <div @click="clickedTab(1)" class="tab" :class="{ selected: selectedTab === 'track' }" data-cy="track-offer-tab">
        <svg viewBox="0 0 512 512" class="sb-icon">
          <use xlink:href="#gift-icon"></use>
        </svg>
        <div>track</div>
        <div>offer</div>
      </div>

      <div @click="clickedTab(3)" class="tab" :class="{ selected: selectedTab === 'target' }" data-cy="target-wallet-tab">
        <svg viewBox="0 0 890.5 890.5" class="sb-icon">
          <use xlink:href="#wallet-icon"></use>
        </svg>
        <div>target</div>
        <div>wallet</div>
      </div>

      <div @click="clickedTab(4)" class="tab" :class="{ selected: selectedTab === 'link' }" data-cy="any-link-tab">
        <svg viewBox="0 0 512.092 512.092" class="sb-icon">
          <use xlink:href="#link-icon"></use>
        </svg>
        <div>any</div>
        <div>link</div>
      </div>
    </section>

    <section class="wrapper">
      <div class="content">
        <transition name="fade" mode="out-in">
          <div class="no-tab-selected tab-content" v-if="!selectedTab">
            select an icon above to add a link for a digital coupon, target a specific part of the wallet or link to any website
          </div>

          <track-offer class="tab-content" v-if="selectedTab === 'track'"/>
          <target-wallet class="tab-content" v-if="selectedTab === 'target'" />
          <any-link class="tab-content" v-if="selectedTab === 'link'" />
        </transition>

        <transition name="fade" mode="out-in">
          <div v-if="!!selectedTab" class="cancel-wrapper tab-content">
            <span class="cancel-btn" @click="clickedCancel">cancel</span>
          </div>
        </transition>
      </div>
    </section>
  </main>
</template>

<script>
import TrackOffer from "./track-offer";
import TargetWallet from "./target-wallet";
import AnyLink from "./any-link";
import {rewardAPI} from "../../../services/api/rewardAPI";
import {mapGetters} from "vuex";

export default {
  name: "campaign-extensions",
  components: {AnyLink, TargetWallet, TrackOffer},
  methods: {
    async clickedTab(tab) {
      if(tab === 1 && !this.campaign.reward_id) {
        await rewardAPI.create(this.campaign.id, 'Campaign')
      }

      await this.$store.dispatch('UPDATE_CAMPAIGN', { _type: tab })
    },
    clickedCancel() {
      this.$store.dispatch('UPDATE_CAMPAIGN', { _type: 0 })
    },
  },
  computed: {
    // FIXME: Replace with date-fns later
    selectedTab() {
      if([1, 5, 6].includes(this.campaign.extension_type)) {
        if(!this.campaign.reward_id) {
          return null;
        }

        return 'track';
      } else if(this.campaign.extension_type === 3) {
        return 'target';
      } else if(this.campaign.extension_type === 4) {
        return 'link';
      }
    },

    ...mapGetters(['campaign'])
  }
}
</script>

<style scoped>
.campaign-extensions {
  display: flex;
  flex-direction: column;
  font-family: "AileronLight";
  position: relative;
  border: 1px solid #128ff9;
  border-left: none;
  border-radius: 0 8px 8px 0;
  width: 40%;
}

a {
  font-family: "AileronLight";
}

.extensions-bar {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  font-size: 12px;
  line-height: 1;
  background-color: rgba(18, 143, 249, 0.15);
}

.sb-icon {
  width: 20px;
}

.tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 0;
  cursor: pointer;
  font-family: AileronThin;
  flex-grow: 1;
}

.tab:hover, .tab.selected {
  color: #128ff9;
  fill: #128ff9;
}

.wrapper {
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 5px 10px;
}

.cancel-wrapper {
  text-align: right;
  align-self: end;
  width: 100%;
}

.no-tab-selected {
  text-align: center;
  font-size: 14px;
  font-family: AileronThin;
  color: #4a4a4a;
}

.cancel-btn {
  font-size: 16px;
  font-family: 'AileronThin';
  color: #a4a4a4;
  cursor: pointer;
}

.cancel-btn:hover {
  color: #f91253;
}
</style>
